import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

import { FooterListComponent } from "./components/FooterList/FooterList.builder";
import { footerInputs } from "./inputs/footerInputs";

import {
  ContactDetailsName,
  FindStoreBannerName,
  SubscribeFormName,
} from "./components";

export const FooterComponent: RegisteredComponent = {
  name: "Footer",
  models: [getBuilderModelName("footer")],
  component: dynamic(() => import("./Footer").then((mod) => mod.Footer)),
  inputs: footerInputs,
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  childRequirements: {
    message: `Only ${SubscribeFormName}, ${FindStoreBannerName}, ${ContactDetailsName}, ${FooterListComponent.name} are allowed`,
    query: {
      "component.name": {
        $in: [
          SubscribeFormName,
          FindStoreBannerName,
          ContactDetailsName,
          FooterListComponent.name,
        ],
      },
    },
  },
};
